import { ImportEmailComponent } from './import-email/import-email.component';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { Component, ElementRef, HostListener, ViewChild, OnInit, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NgClass } from '@angular/common';
import { EntityEmailService } from 'app/entities/emails/emails.service';
import { Email, Attachment } from 'app/entities/emails/emails-model';
import { MdDialogConfig, MdDialogRef, MdDialog } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";
import { Response } from '@angular/http/src/static_response';


@Component({
  templateUrl: './emails.component.html'
})

export class EntityEmailsComponent implements OnInit {
  entityIdDetails: EntityIdDetails;
  emails: Email[] = [];
  selectedEmail: Email;
  loading: boolean = false;

  isRecordNumberMoreThanLimit = true;
  maxRecordsToBeDisplayed = 10;
  currentEmailRecords = 0;
  numberOfEntries = 0;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public entityDetailsService: EntityDetailsService,
    public domSanitizer: DomSanitizer,
    public dialog: MdDialog,
    public entityEmailService: EntityEmailService) {
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    if (this.entityIdDetails.entityId) {
      this.loadEmail();
    } else {
      this.entityDetailsService.entityDetailsUpdated.subscribe(
        (entityDetails) => {
          this.entityIdDetails = entityDetails;
          this.loadEmail();
        }
      );
    }
  }

  loadEmail() {
    this.loading = true;
    this.entityEmailService.getEmails(this.entityIdDetails.entityId, this.currentEmailRecords,
      this.maxRecordsToBeDisplayed)
      .subscribe(response => {
        if (response) {
          this.loading = false;
          this.emails = this.emails.concat(response);
          this.selectedEmail = this.emails[0];
        }
      });
  }

  selectEmail(email) {
    this.selectedEmail = email;
  }

  onScrollDown() {
    this.currentEmailRecords = this.emails.length;
    this.loadEmail();

  }

  openImportEmails() {
    this.loading = true;
    this.dialog.open(ImportEmailComponent).afterClosed().subscribe(result => {
      this.emails = [];
      this.currentEmailRecords = 0;
      this.ngOnInit();
    }
    );
  }

  openAttachment(attachmentId, attachmentName) {
    this.entityEmailService.getAttachmentContent(this.selectedEmail.id, attachmentId).subscribe(blob => {
      importedSaveAs(blob, attachmentName);
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/entities/emails/emails.component.ts